module.exports = __webpack_public_path__ + "img/42a5d34.png";